// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
import Description from '../../ui-helper-elements/Description'
import HoverMRRDescription from './HoverMRRDescription'
// JS Imports
import { formatFloatAsCurrencySymbol } from '../../../common/helpers.mjs'
// Asset Imports

export default function PayrollStatesProductRow() {
   const state = useQuoteContext()
   const { getString } = state
   const permissionsShowMRROnDifferenceQuotes =
      state.featurePermissions['ShowMRROnDifferenceQuotes']
   const ShowMRROnDifferenceQuotes =
      permissionsShowMRROnDifferenceQuotes.includes(state.user_role)

   if (
      state.user_role != 'Partner' &&
      state.user_role != 'Reseller' &&
      (state.user_view == 'Internal' ||
         state.productPayrollTotalStateCount > 0 ||
         (state.hasUSEmployees == true && state.productPayrollTotalEECount > 0))
   )
      return (
         <div className='row'>
            <div className='col-bhr1'>
               {state.productPayrollEINCount > 1
                  ? 'Additional States'
                  : state.product_list['states']['ProductName']}{' '}
               (
               {formatFloatAsCurrencySymbol(
                  state.product_list['states']['EmpListPrice'],
                  state.currencyObjectUSD,
               )}
               {state.productPayrollEINCount > 0 ? '' : '/Additional State'})
            </div>
            <div className='col-bhr2'>
               <input
                  className='form-control'
                  type='number'
                  value={state.productPayrollTotalStateCount}
                  disabled
               />
            </div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col'>
               {formatFloatAsCurrencySymbol(
                  state.productPayrollMonthlyStateTotalCosts.totalPrice,
                  state.currencyObjectUSD,
               )}
            </div>
            {state.differenceQuote == true ? (
               <>
                  <Description
                     className='col col-bhr-blue'
                     title={getString(
                        'product.PayrollStatesProductRow.Description.Title',
                     )}
                     placement='bottom'
                     popoverClassName='popover-wide'
                     content={
                        <div className='row text-nowrap'>
                           <p className='col'>{getString('global.Quantity')}</p>
                           <p className='col text-end'>
                              {formatFloatAsCurrencySymbol(
                                 state.productPayrollMonthlyStateTotalCosts
                                    .previousTotalPrice || 0,
                                 state.currencyObjectUSD,
                                 true,
                              )}
                           </p>
                        </div>
                     }
                  >
                     <span className='hoverable'>
                        {formatFloatAsCurrencySymbol(
                           state.productPayrollMonthlyStateTotalCosts
                              .previousTotalPrice || 0,
                           state.currencyObjectUSD,
                        )}
                     </span>
                  </Description>
                  {ShowMRROnDifferenceQuotes ? (
                     <HoverMRRDescription
                        listMRRTotal={
                           state.productPayrollMonthlyStateTotalCosts
                              .listMRRTotal
                        }
                        previousMRRTotal={
                           state.productPayrollMonthlyStateTotalCosts
                              .previousMRRTotal
                        }
                        MRRTotal={
                           state.productPayrollMonthlyStateTotalCosts.MRRTotal
                        }
                        MRRTotalUSD={
                           state.productPayrollMonthlyStateTotalCosts
                              .MRRTotalUSD
                        }
                        currencyObjectCurrent={state.currencyObject}
                        currencyObjectUSD={state.currencyObjectUSD}
                     >
                        <span className='hoverable'>
                           {formatFloatAsCurrencySymbol(
                              state.productPayrollMonthlyStateTotalCosts
                                 .totalPriceDifference,
                              state.currencyObjectUSD,
                              true,
                           )}
                        </span>
                     </HoverMRRDescription>
                  ) : (
                     <span className='col'>
                        {formatFloatAsCurrencySymbol(
                           state.productPayrollMonthlyStateTotalCosts
                              .totalPriceDifference,
                           state.currencyObjectUSD,
                        )}
                     </span>
                  )}
               </>
            ) : (
               <></>
            )}
         </div>
      )
}
